import { render, staticRenderFns } from "./TabelaResultadosCessoes.vue?vue&type=template&id=7805e406&scoped=true&"
import script from "./TabelaResultadosCessoes.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosCessoes.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadosCessoes.vue?vue&type=style&index=0&id=7805e406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7805e406",
  null
  
)

export default component.exports